l = require 'lib/localize'
t = require('views/internal/recup-with-helpers')('org_account')
ApiError = require 'network/api-error'
BoardCreateVisibilityRestrictionsComponent = require 'views/enterprise/dashboard/teams-settings/board-create-visibility-restrictions-component'
ExternalMembersDisabledComponent = require 'views/enterprise/dashboard/teams-settings/external-members-disabled-component'
VisibilityComponent = require 'views/enterprise/dashboard/teams-settings/visibility-component'
RestrictionsComponent = require 'views/enterprise/dashboard/teams-settings/restrictions-component'
AttachmentRestrictionsComponent = require 'views/enterprise/dashboard/teams-settings/attachment-restrictions-component'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
ReactDOM = require 'react-dom'
SettingSectionComponent = require 'views/enterprise/dashboard/teams-settings/setting-section-component'
SettingMultiSectionComponent = require 'views/enterprise/dashboard/teams-settings/setting-multi-section-component'

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)

  displayName: 'TeamsSettingsComponent'

  render: t.renderable ->
    t.div =>
      t.div '.window-module-title.settings-header', ->
        t.h1 ->
          t.format ['ent-settings']
          t.span '.settings-subtitle', ->
            t.text t.l ['ent-team-settings-info']
      t.addElement @getVisibilitySection()
      t.addElement @getTeamMembershipRestrictionsSection()
      t.addElement @getBoardCreateVisibilityRestrictionsSection()
      t.addElement @getExternalMembersDisabledSection()
      t.addElement @getAttachmentRestrictionsSection()

  getVisibilitySection: ->
    React.createElement SettingSectionComponent,
      header: t.render -> t.span ->
        t.format "team-visibility"
      contents: React.createElement VisibilityComponent,
        visibility: @props.permissionLevel
      onChange: @props.openChangeVisibility

  getTeamMembershipRestrictionsSection: ->
    React.createElement SettingSectionComponent,
      header: t.render -> t.span ->
        t.format "team-membership-restrictions"
      contents: React.createElement RestrictionsComponent,
        orgInviteRestrict: @props.orgInviteRestrict
      onChange: @props.openChangeMembershipRestrictions

  getBoardCreateVisibilityRestrictionsSection: ->
    React.createElement SettingMultiSectionComponent,
      header: t.render -> t.span ->
        t.format "team-board-creation-restrictions"
      contents:
        public: React.createElement BoardCreateVisibilityRestrictionsComponent,
          onNewTabClick: @props.onNewTabClick
          publicBoardCount: @props.publicBoardCount
          restrictions: @props.boardVisibilityRestrictions
          visibility: 'public'
        org: React.createElement BoardCreateVisibilityRestrictionsComponent,
          restrictions: @props.boardVisibilityRestrictions
          visibility: 'org'
        private: React.createElement BoardCreateVisibilityRestrictionsComponent,
          restrictions: @props.boardVisibilityRestrictions
          visibility: 'private'
      onChange:
        public: @props.openChangeBoardVisRestrictions.public
        org: @props.openChangeBoardVisRestrictions.org
        private: @props.openChangeBoardVisRestrictions.private

  getExternalMembersDisabledSection: ->
    React.createElement SettingSectionComponent,
      header: t.render -> t.span ->
        t.format "team-board-invitation-restrictions"
      contents: React.createElement ExternalMembersDisabledComponent,
        externalMembersDisabled: @props.externalMembersDisabled
      onChange: @props.openChangeExternalMembersDisabled

  getAttachmentRestrictionsSection: ->
    React.createElement SettingSectionComponent,
      header: t.render -> t.span ->
        t.format "attachments"
      contents: React.createElement AttachmentRestrictionsComponent,
        attachmentRestrictions: @props.attachmentRestrictions
      onChange: @props.openChangeAttachmentRestrictions



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/teams-settings-component.coffee